import { Button, Paper, TextInput, NumberInput, Stack } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAddCategory, useUpdateCategory } from "../../utils/mutations";
import { useCategoryById } from "../../utils/queries";
import useStore from "../../utils/store";

const AddCategory = () => {
  const user = useStore((state) => state.user);
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id;

  const [name, setName] = useState("");
  const [position, setPosition] = useState("");

  useEffect(() => {
    if (id && !user?.updateCategory) {
      notifications.show({ message: "You don't have permission to edit categories", color: "red" });
      navigate("/categories");
    } else if (!id && !user?.addCategory) {
      notifications.show({ message: "You don't have permission to add categories", color: "red" });
      navigate("/categories");
    }
  }, [id, user]);

  const { isPending, mutate } = useAddCategory();
  const { isPending: isUpdating, mutate: update } = useUpdateCategory();
  const { data, isLoading } = useCategoryById(params.id);

  useEffect(() => {
    if (data) {
      setName(data.name || "");
      setPosition(data.position || "");
    }
  }, [data]);

  if (!user?.addCategory && !user?.updateCategory) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const values = { name, position };
    if (id) update({ id, data: values });
    else mutate(values);
  };

  return (
    <>
      <Paper
        withBorder
        p="md"
        loading={isLoading}
        style={{ maxWidth: 500, width: "100%", marginInline: "auto" }}
      >
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <NumberInput label="Position" value={position} onChange={setPosition} />
            <TextInput label="Name" value={name} onChange={(e) => setName(e.target.value)} required />
            <Button type="submit" loading={isPending || isUpdating}>
              {id ? "Update" : "Add"}
            </Button>
          </Stack>
        </form>
      </Paper>
    </>
  );
};

export default AddCategory;
